import { MenuOpenIcon } from './MenuOpenIcon';

/**
 * author: Google
 * id AEB414A7-E7A2-46D6-BAA3-CAFA4E06DA38
 * name menu-open
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-open.svg
 * tags
 */
export const HamburgerOpenIcon = MenuOpenIcon;
export default HamburgerOpenIcon